import {
  faTractor,
  faChartArea,
  faCogs,
  faFileSignature,
  faUsers,
  faClipboardCheck,
  faFileMedical,
  faNewspaper,
  // faWallet,
  faSeedling,
  // faStreetView,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import React, { lazy } from "react";
import { Route } from "react-router-dom";
import ContactUs from "./pages/public/website/contact-us.component";

// Portal Components

const DashboardComponent = lazy(() =>
  import("./pages/admin/dashboard/dashboard.container")
);
const UsersComponent = lazy(() =>
  import("./pages/admin/users/users.component")
);
const EntriesComponent = lazy(() =>
  import("./pages/admin/entries/entries.component")
);
// const PaymentComponent = lazy(() =>
//   import("./pages/admin/payments/payment.component")
// );
const PostsComponent = lazy(() =>
  import("./pages/admin/posts/posts.component")
);
const TractorOwnerComponent = lazy(() =>
  import("./pages/admin/tractor/owner/tractor-owner.component")
);
const TractorProfileComponent = lazy(() =>
  import("./pages/admin/tractor/owner/tractor-profile.component")
);
const EnlistTractorComponent = lazy(() =>
  import("./pages/admin/tractor/owner/enlist-tractor.component")
);
const TractorLeasingComponent = lazy(() =>
  import("./pages/admin/tractor/leasing/tractor-leasing.component")
);
const HireTractorComponent = lazy(() =>
  import("./pages/admin/tractor/leasing/hire-tractor.component")
);
const InvestInTractorComponent = lazy(() =>
  import("./pages/admin/invest/invest-in-tractor.component")
);
// const TrackTractorComponent = lazy(() =>
//   import("./pages/admin/tractor/tracker/track-tractor.component")
// );
const TractorAdminComponent = lazy(() =>
  import("./pages/admin/tractor/admin/tractor-admin.component")
);
const BulkUploadComponent = lazy(() =>
  import("./pages/admin/users/bulk-upload.component")
);
const UserProfileComponent = lazy(() =>
  import("./pages/admin/users/profile.component")
);
const NewInvestmentComponent = lazy(() =>
  import("./pages/admin/invest/addnew-invest.component")
);

const InvestmentComponent = lazy(() =>
  import("./pages/admin/invest/invest-list.component")
);

// Public Components

const HomeComponent = lazy(() =>
  import("./pages/public/website/home.component")
);

const AboutUsComponent = lazy(() =>
  import("./pages/public/website/about-us.component")
);

const FarmersComponent = lazy(() =>
  import("./pages/admin/farmers/view-farmers.component")
);

const InvestmentRequestSentComponent = lazy(() =>
  import("./pages/admin/invest/invest-request-sent.component")
);
export const dashboardRoutes = {
  all: [
    {
      path: "/user/dashboard",
      name: "Dashboard",
      icon: faChartArea,
      component: DashboardComponent,
      layout: "/user",
    },
    {
      path: "/user/farmer",
      name: "Farmers",
      icon: faChartArea,
      component: FarmersComponent,
      layout: "/user",
    },
    {
      path: "/user/tractor/hire",
      name: "Hire Tractors",
      icon: faTractor,
      render: ({ match: { url } }) => (
        <>
          <Route path={`${url}/`} component={TractorLeasingComponent} exact />
          <Route path={`${url}/request`} component={HireTractorComponent} />
        </>
      ),
      layout: "/user",
    },
    {
      path: "/settings",
      name: "Settings",
      icon: faCogs,
      component: UserProfileComponent,
      layout: "/setting",
    },
    {
      path: "/user/tractor/owner",
      name: "Enlist Tractors",
      icon: faFileMedical,
      render: ({ match: { url } }) => (
        <>
          <Route path={`${url}/`} component={TractorOwnerComponent} exact />
          <Route path={`${url}/enlist`} component={EnlistTractorComponent} />
          <Route
            path={`${url}/tractor-profile`}
            component={TractorProfileComponent}
          />
        </>
      ),
      layout: "/user",
    },
    // {
    //   path: "/user/tracker",
    //   name: "Track Tractor",
    //   icon: faStreetView,
    //   component: TrackTractorComponent,
    //   layout: "/user",
    // },
    {
      path: "/user/invest",
      name: "Invest",
      icon: faSeedling,
      render: ({ match: { url } }) => (
        <>
          <Route path={`${url}/`} component={InvestInTractorComponent} exact />
          <Route
            path={`${url}/new-invest`}
            component={NewInvestmentComponent}
          />
          <Route
            path={`${url}/request/sent`}
            component={InvestmentRequestSentComponent}
          />
        </>
      ),
      layout: "/user",
    },
    // {
    //   path: "/user/wallet",
    //   name: "Wallet",
    //   icon: faWallet,
    //   component: PaymentComponent,
    //   layout: "/user",
    // },
    {
      path: "/user/profile",
      name: "Profile",
      icon: faUserCircle,
      component: UserProfileComponent,
      layout: "/user",
    },
  ],
  admin: [
    {
      path: "/admin/dashboard",
      name: "Dashboard",
      icon: faChartArea,
      component: DashboardComponent,
      layout: "/admin",
    },
    {
      path: "/admin/tractors",
      name: "Tractor ",
      icon: faClipboardCheck,
      component: TractorAdminComponent,
      layout: "/admin",
    },
    {
      path: "/admin/posts",
      name: "Posts",
      icon: faNewspaper,
      component: PostsComponent,
      layout: "/admin",
    },
    {
      path: "/admin/entries",
      name: "Entries",
      icon: faFileSignature,
      component: EntriesComponent,
      layout: "/admin",
    },
    {
      path: "/admin/update/investment",
      name: "Investments",
      icon: faUsers,
      component: InvestmentComponent,
      layout: "/admin",
    },
    {
      path: "/admin/users",
      name: "Users",
      icon: faUsers,
      render: ({ match: { url } }) => (
        <>
          <Route path={`${url}/`} component={UsersComponent} exact />
          <Route path={`${url}/bulk-upload`} component={BulkUploadComponent} />
        </>
      ),
      layout: "/admin",
    },
  ],
  user: [],
  farmer: [],
  agent: [],
  msp: [],
  investor: [],
};

export const publicRoutes = [
  {
    title: "Contact Us",
    component: ContactUs,
    path: "/contact",
  },
  {
    title: "About",
    component: AboutUsComponent,
    path: "/about",
  },
  {
    title: "Home",
    component: HomeComponent,
    path: "/",
  },
];
